import { render, staticRenderFns } from "./SportsAutocompleteSingle.vue?vue&type=template&id=715af7e2&scoped=true"
import script from "./SportsAutocompleteSingle.vue?vue&type=script&lang=js"
export * from "./SportsAutocompleteSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715af7e2",
  null
  
)

export default component.exports